import { useContext } from 'react'
import swal from 'sweetalert2'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock, faUnlock } from '@fortawesome/pro-light-svg-icons'

import { Box, Button, Text } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import useAgency from '@hooks/useAgency'
import useCurrentUser from '@hooks/useCurrentUser'

const confirmUnlock = (toggleAgencyLock: Function, toggleFn: Function) => {
  const toggleAgencyLockPayload = {
    callbacks: {
      action: toggleFn,
    },
    toastText: 'Agency Unlocked',
  }

  swal.fire({
    confirmButtonColor: '#DD6B55',
    confirmButtonText: 'Yes, unlock it.',
    icon: 'warning',
    showCancelButton: true,
    text: 'Are you sure?',
    title: 'Unlock Agency?',
  }).then(({ value }) => {
    if (value){
      toggleAgencyLock(toggleAgencyLockPayload)
    }
  })
}

type AgencyLockedBannerProps = {
  agencyPayload: ReturnType<typeof useAgency>,
}

const AgencyLockedBanner = (props: AgencyLockedBannerProps) => {
  const {
    agencyPayload: {
      agency: {
        locked_by_user_id,
      },
      callbacks: {
        toggleAgencyLock: toggleFn,
      },
      lockedByUser: {
        full_name,
      },
    },
  } = props

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      toggleAgencyLock,
    },
  } = pageContext

  const {
    currentUser: {
      id,
    },
  } = useCurrentUser()

  return (
    <Box alignItems="center" flexDirection={['column', 'row']} marginBottom="large" padding="large" variant="white">
      <Box>
        <Box
          backgroundColor="pink"
          borderRadius={5}
          color="red"
          fontSize="large"
          padding="large"
          width="fit-content"
        >
          <FontAwesomeIcon icon={faLock} />
        </Box>

        <Box flexDirection="column" justifyContent="center" marginLeft="large">
          <Text fontSize="small">Agency locked by {full_name}</Text>
        </Box>
      </Box>

      {id === locked_by_user_id && (
        <Button
          buttonStyle="secondaryUtility"
          //@ts-expect-error
          height="fit-content"
          icon={<FontAwesomeIcon icon={faUnlock} />}
          marginTop={['large', 0]}
          onClick={() => confirmUnlock(toggleAgencyLock, toggleFn)}
          size="medium"
          width={['100%', 'fit-content']}
        >
          Unlock Agency
        </Button>
      )}
    </Box>
  )
}

export default AgencyLockedBanner
